import { render } from "./CommonMap.vue?vue&type=template&id=071f46c4&ts=true"
import script from "./CommonMap.vue?vue&type=script&lang=tsx"
export * from "./CommonMap.vue?vue&type=script&lang=tsx"

import "./CommonMap.vue?vue&type=style&index=0&id=071f46c4&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__